import type { Goal } from "instantdb/types";
import { instantClientDB } from "instantdb/instantClient";
import { id } from "@instantdb/admin";

// Get all goals for a user
export function getGoals(userId?: string) {
  const { data, isLoading } = instantClientDB.useQuery({
    goals: {
      $: {
        where: {
          userId: userId ?? "",
        },
      },
      healthArea: {},
    },
  });

  if (!userId) {
    return {
      goals: [],
      isLoading: false,
    };
  }

  return {
    goals: data?.goals ?? [],
    isLoading: !!userId && isLoading,
  };
}

// Create or update a goal
export async function upsertGoal(goal: Goal) {
  // @ts-expect-error healthArea might exist on goal type
  const { id: inputId, healthArea, ...goalData } = goal;
  const goalId = inputId ?? id();

  // Build transaction steps
  const txSteps = [instantClientDB.tx.goals[goalId].update(goalData)];

  // If healthArea is provided with an id, link the goal to that healthArea
  // @ts-expect-error healthArea might exist on goal type
  if (goal.healthArea?.id) {
    txSteps.push(
      // @ts-expect-error accessing healthArea id
      instantClientDB.tx.healthAreas[goal.healthArea.id].link({ goals: [goalId] }),
    );
  }

  await instantClientDB.transact(txSteps).catch((error) => {
    console.error("Error upserting goal:", goal, error);
  });

  return goalId;
}

// Delete a goal
export async function deleteGoal(id: string) {
  await instantClientDB.transact([instantClientDB.tx.goals[id].delete()]);
}
